import { render, staticRenderFns } from "./scertificate.vue?vue&type=template&id=4a5484eb&scoped=true&"
import script from "./scertificate.vue?vue&type=script&lang=js&"
export * from "./scertificate.vue?vue&type=script&lang=js&"
import style0 from "./scertificate.vue?vue&type=style&index=0&id=4a5484eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5484eb",
  null
  
)

export default component.exports